import React, { useState } from "react";
import styles from "./Pagination.module.css";
import leftArrow from "../../assets/icons/left_arrow.svg";
import rightArrow from "../../assets/icons/rightArrow.svg";
import downArrow from "../../assets/icons/down-arrow.svg";

const Pagination = ({
  rowsPerPage,
  currentPage,
  totalPages,
  totalRecords,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const rowOptions = [ 5, 10 , 20, 30 , 50, 100, 150, 200, 250, 300, 350, 400 , 450 , 500]; 

  const handlePageChange = (page) => {
    const clamped = Math.max(1, Math.min(totalPages, page));
    onPageChange?.(clamped);
  };

  const handlePrevious = () => handlePageChange(currentPage - 1);
  const handleNext = () => handlePageChange(currentPage + 1);

  const handleRowsChange = (rows) => {
    onRowsPerPageChange?.(rows);
    handlePageChange(1);
    setIsDropdownOpen(false);
  };

  const renderPageNumbers = () => {
    const pages = [];
    const total = totalPages;
    const current = currentPage;
    const siblingCount = 1;

    const startPage = Math.max(1, current - siblingCount);
    const endPage = Math.min(total, current + siblingCount);

    if (startPage > 1) {
      pages.push(
        <button
          key="page-1"
          className={`${styles.pageButton} ${
            current === 1 ? styles.active : ""
          }`}
          onClick={() => handlePageChange(1)}
        >
          1
        </button>
      );

      if (startPage > 2) {
        pages.push(
          <span key="start-ellipsis" className={styles.ellipsis}>
            ...
          </span>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={`page-${i}`}
          className={`${styles.pageButton} ${
            current === i ? styles.active : ""
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    if (endPage < total) {
      if (endPage < total - 1) {
        pages.push(
          <span key="end-ellipsis" className={styles.ellipsis}>
            ...
          </span>
        );
      }

      pages.push(
        <button
          key={`page-${total}`}
          className={`${styles.pageButton} ${
            current === total ? styles.active : ""
          }`}
          onClick={() => handlePageChange(total)}
        >
          {total}
        </button>
      );
    }

    return pages;
  };

  const startRecord = totalRecords > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const endRecord = Math.min(currentPage * rowsPerPage, totalRecords || 0);

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.rowsPerPage}>
        <span className={styles.rowsText}>Rows Per Page</span>

        <div className={styles.dropdownWrapper}>
          <button
            className={styles.dropdownButton}
            onClick={() => setIsDropdownOpen((s) => !s)}
            type="button"
          >
            <span>{rowsPerPage}</span>
            <img src={downArrow} alt="open" className={styles.dropdownIcon} />
          </button>

          {isDropdownOpen && (
            <div className={styles.dropdownMenu}>
              {rowOptions.map((option) => (
                <div
                  key={option}
                  className={styles.dropdownItem}
                  onClick={() => handleRowsChange(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className={styles.pageNumbers}>{renderPageNumbers()}</div>

      <div className={styles.navigation}>
        <button
          className={`${styles.navButton} ${
            currentPage === 1 ? styles.disabled : ""
          }`}
          onClick={handlePrevious}
          disabled={currentPage === 1}
          type="button"
        >
          <img src={leftArrow} alt="Previous" />
        </button>

        <button
          className={`${styles.navButton} ${
            currentPage === totalPages ? styles.disabled : ""
          }`}
          onClick={handleNext}
          disabled={currentPage === totalPages}
          type="button"
        >
          <img src={rightArrow} alt="Next" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;